// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2gAlk","title":"Header_title__3ii82","left":"Header_left__1-Fd3","clinicName":"Header_clinicName__3j1AK"};